import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import UploadFile from '../../../../components/UploadFile';
import SelectTag from '../../../../components/SelectTag';

const CreateProductTicket = ({ show, handleClose, handleSubmit, onProductTicketSubmit, control, register, errors, priorityOptions = [], statusOptions = [], productOptions = [], customerOptions = [], setCustomerId = {} }) => {
  const [uploadedUrls, setUploadedUrls] = useState([]);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let productList = productOptions.map(product => ({
      value: product.id,
      label: product.name,
    }));
    setOptions(productList);
  }, [productOptions]);
  const handleFileUpload = (urls) => {
    setUploadedUrls(urls);
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Create Product Ticket</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit((data) => onProductTicketSubmit({ ...data, document: uploadedUrls }))}>
          {customerOptions.length > 0 && (
              <div className="mb-3">
                <label className="form-label fw-bold">Customer</label>
                <SelectTag
                  name="customer_id"
                  control={control}
                  options={customerOptions}
                  label="customer"
                  onChange={(selectedCustomer) => {
                    setCustomerId(selectedCustomer?.value);
                  }}
                />
                {errors?.customer_id && <small className="text-danger">{errors?.customer_id?.message}</small>}
              </div>
          )}
          <div className="mb-3">
            <label className="form-label fw-bold">Product</label>
            <Controller
              name="customer_product_id"
              control={control}
              rules={{required: 'Product is required.' }}
              render={({ field }) => (
                <select {...field} className="form-select">
                  <option value="">Select a Product</option>
                  {options.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              )}
            />
            {errors?.customer_product_id && <small className="text-danger">{errors?.customer_product_id?.message}</small>}
          </div>
          <div className="row">
            <div className="col-md-6">
              <label className="fw-bold">Priority</label>
              <SelectTag
                name="priority"
                control={control}
                options={priorityOptions}
                label="priority"
                defaultValue={priorityOptions[0]}
                isRequired={true}
              />
              {errors?.priority && (
                <p className="text-danger mt-2">{errors?.priority?.message}</p>
              )}
            </div>
            <div className="col-md-6">
              <label className="fw-bold">Status</label>
              <SelectTag
                name="status"
                control={control}
                options={statusOptions}
                label="status"
                defaultValue={statusOptions[0]}
                isRequired={true}
              />
              {errors?.status && (
                <p className="text-danger mt-2">{errors?.status?.message}</p>
              )}
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <label htmlFor='title' className="fw-bold">Title</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter title"
                {...register('title', {
                  required: 'Title is required.',
                  maxLength: {
                    value: 60,
                    message: 'Title must not exceed 60 characters.',
                  },
                })}
              />
              {errors?.title && (
                <p className="text-danger mt-2">{errors?.title?.message}</p>
              )}
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <label htmlFor='description' className="fw-bold">Description</label>
              <textarea
                className="form-control"
                placeholder="Enter description"
                {...register('description', {
                  required: 'Description is required.',
                  maxLength: {
                    value: 255,
                    message: 'Description must not exceed 255 characters.',
                  },
                })}
              />
              {errors?.description && (
                <p className="text-danger mt-2">{errors?.description?.message}</p>
              )}
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <label className="fw-bold">Document</label>
              <UploadFile folderName="support-ticket" onFileUpload={handleFileUpload} />
            </div>
          </div>
          <div className="modal-footer">
            <Button variant="danger" size='sm' onClick={handleClose}>
              Cancel
            </Button>
            <Button type="submit" variant="primary" size='sm'>
              Create
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateProductTicket;
